import { useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { SidebarContent } from "./Sidebar";
import { Topbar } from "./Topbar";
import { Sheet, SheetContent } from "@/components/ui/sheet";
import { cn } from "@/lib/utils";

// Routes that should render as an immersive, distraction-free workspace.
const IMMERSIVE_ROUTES = ["/consultation/new"];

export default function AppLayout() {
  const [userCollapsed, setUserCollapsed] = useState(() => localStorage.getItem("contaha_collapsed") === "1");
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const immersive = IMMERSIVE_ROUTES.includes(location.pathname);
  const collapsed = immersive ? true : userCollapsed;

  useEffect(() => {
    localStorage.setItem("contaha_collapsed", userCollapsed ? "1" : "0");
  }, [userCollapsed]);

  return (
    <div className="flex h-screen overflow-hidden bg-[#F8F9F8] dark:bg-[#07131A]">
      {/* Desktop sidebar */}
      <aside
        className={cn(
          "hidden lg:block shrink-0 transition-[width] duration-300 ease-out",
          collapsed ? "w-[72px]" : "w-[248px]"
        )}
      >
        <SidebarContent collapsed={collapsed} onToggle={immersive ? undefined : () => setUserCollapsed((c) => !c)} />
      </aside>

      {/* Mobile drawer */}
      <Sheet open={mobileOpen} onOpenChange={setMobileOpen}>
        <SheetContent side="left" className="w-[280px] p-0 border-0 bg-[#07131A]">
          <SidebarContent collapsed={false} onNavigate={() => setMobileOpen(false)} />
        </SheetContent>
      </Sheet>

      <div className="flex flex-1 flex-col overflow-hidden">
        <Topbar onMenu={() => setMobileOpen(true)} quiet={immersive} />
        <main className="flex-1 overflow-y-auto thin-scroll">
          <div className={cn(immersive ? "" : "mx-auto max-w-[1440px] px-4 py-6 lg:px-8 lg:py-8 animate-fade-up")}>
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
